import React, { FC } from "react"

type Props = {
  message: string
}

export const InputError: FC<Props> = ({ message }) => {
  return <p className="text-xs text-red-500">{message}</p>
}
